import type {
  BrandTheme,
  CheckoutTheme,
  OffersPageTheme,
} from '@trmediaab/zebra';
import { createTheme } from '@trmediaab/zebra';

import { borderWidths, radii, shadows } from './border';
import breakpoints from './breakpoints';
import colors from './colors';
import sizes from './sizes';
import {
  fontFaceDefinitions,
  fonts,
  fontSizes,
  fontWeights,
  lineHeights,
} from './typography';
import anchor from './variants/anchor';
import box from './variants/box';
import button from './variants/button';
import container from './variants/container';
import divider from './variants/divider';
import heading from './variants/heading';
import html from './variants/html';
import text from './variants/text';
import textInput from './variants/textInput';
import zIndices from './zIndices';

const brandTheme: BrandTheme & CheckoutTheme & OffersPageTheme = {
  borderWidths,
  breakpoints,
  colors,
  fonts,
  fontFaceDefinitions,
  fontSizes,
  fontWeights,
  lineHeights,
  radii,
  shadows,
  sizes,
  zIndices,
  components: {
    anchor,
    box,
    button,
    container,
    divider,
    heading,
    html,
    text,
    textInput,
  },
};

const theme = createTheme(brandTheme);

export type JokersystemetTheme = typeof theme;

export default theme;
